import { useEffect, useRef, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
function MapSetter({ mapRef }) {
  const map = useMap();

  useEffect(() => {
    mapRef.current = map;
  }, [map, mapRef]);

  return null;
}
export default function Directory() {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [businesses, setBusinesses] = useState([]);
  const mapRef = useRef(null);
  const markerRefs = useRef({});

  const categories = [
    "All",
    "Food",
    "Beauty & Wellness",
    "Childcare & Family",
    "Education",
    "Shopping",
    "Services",
  ];

  useEffect(() => {
    fetch("/api/businesses")
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) setBusinesses(data);
        else setBusinesses([]);
      })
      .catch(() => setBusinesses([]));
  }, []);

  const safeBusinesses = Array.isArray(businesses) ? businesses : [];

  const filteredBusinesses =
    selectedCategory === "All"
      ? safeBusinesses
      : safeBusinesses.filter((b) => b.category === selectedCategory);

  function focusBusiness(business) {
    if (!business.lat || !business.lng || !mapRef.current) return;

    mapRef.current.setView([business.lat, business.lng], 14, {
      animate: true,
    });

    setTimeout(() => {
      markerRefs.current[business.id]?.openPopup();
    }, 300);
  }

  return (
    <main className="min-h-screen bg-[#f3f1ea]">
      <header className="bg-[#111827] text-white">
        <div className="flex items-center gap-6 px-6 py-4">
          <div className="whitespace-nowrap">
            <p className="text-[10px] uppercase tracking-[0.28em] text-[#d0b182]">
              One Unity Rising
            </p>
            <h1 className="text-xl font-medium tracking-tight">The Blk Bloc</h1>
            <p className="text-xs text-white/60">
              Black-Owned Business Directory
            </p>
          </div>

                    <div className="flex w-full max-w-3xl overflow-hidden rounded-lg bg-white">
            <input
              type="text"
              placeholder="Search city, ZIP, or business"
              className="w-full px-4 py-3 text-sm text-black outline-none"
            />
            <button className="bg-black px-5 text-white">Search</button>
          </div>

          <a
            href="https://airtable.com/appZRnsEWD0YhdP2w/pagqeGcJbV0LCMziQ/form"
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-lg bg-[#d0b182] px-5 py-3 text-sm font-medium text-black"
          >
            Request Listing
          </a>
        </div>
        <div className="flex overflow-x-auto border-t border-white/10 bg-[#111827]">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-6 py-4 text-sm transition ${
                selectedCategory === category
                  ? "bg-white text-black"
                  : "text-white/80 hover:bg-white/10"
              }`}
            >
              {category}
            </button>
          ))}
        </div>
      </header>

      <section className="relative h-[calc(100vh-135px)] w-full overflow-hidden">
<MapContainer
  center={[43.2, -84.6]}
  zoom={6}
  scrollWheelZoom={true}
  className="z-0 h-full w-full"
>
  <MapSetter mapRef={mapRef} />


 
          <TileLayer
            attribution="&copy; OpenStreetMap contributors"
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />

          {filteredBusinesses
            .filter((b) => b.lat && b.lng)
            .map((business) => (
              <Marker
                key={business.id}
                position={[business.lat, business.lng]}
                ref={(ref) => {
                  if (ref) markerRefs.current[business.id] = ref;
                }}
              >
                <Popup>
                  <strong>{business.name}</strong>
                  <br />
                  {business.category}
                  <br />
                  {business.city}
                  {business.website && (
                    <>
                      <br />
                      <a
                        href={business.website}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Visit Website
                      </a>
                    </>
                  )}
                </Popup>
              </Marker>
            ))}
        </MapContainer>

        <div className="absolute left-16 top-6 z-[9999] w-[320px] pointer-events-auto">
          <div className="rounded-xl bg-white shadow-xl">
            <div className="border-b border-black/10 px-5 py-4">
              <h2 className="text-lg font-medium text-[#111827]">Directory</h2>
              <p className="mt-1 text-sm text-gray-500">
                Category: {selectedCategory}
              </p>
            </div>

            <div className="max-h-[420px] space-y-3 overflow-y-auto p-4">
              {filteredBusinesses.length === 0 ? (
                <div className="p-4 text-center">
                  <p className="text-sm text-gray-500">
                    No approved businesses listed yet.
                  </p>

                  <a
                    href="https://airtable.com/appZRnsEWD0YhdP2w/pagqeGcJbV0LCMziQ/form"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-4 inline-block rounded-full bg-black px-5 py-2 text-sm text-white"
                  >
                    Request Listing
                  </a>
                </div>
              ) : (
                filteredBusinesses.map((business) => (
                  <button
                    key={business.id}
                    onClick={() => focusBusiness(business)}
                    className="block w-full rounded-lg bg-[#fbfaf7] p-4 text-left shadow-sm transition hover:bg-white hover:shadow-md"
                  >
                    <h3 className="text-sm font-medium text-[#111827]">
                      {business.name}
                    </h3>
                    <p className="mt-1 text-xs text-[#7a6b5d]">
                      {business.category}
                    </p>
                    <p className="mt-1 text-xs text-[#7a6b5d]">
                      {business.city}
                    </p>
                  </button>
                ))
              )}
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}